import type { CSSProperties } from 'react';

/** Place a side panel just above a corner button, on the same side as the AI assistant. */
export function learnerSidePanelPlacement(anchorStyle: CSSProperties | undefined, isRtl: boolean) {
  const iconBottom = anchorStyle?.bottom;
  const iconRight = anchorStyle?.right;
  const iconLeft = anchorStyle?.left;
  const panelBottom =
    typeof iconBottom === 'number'
      ? iconBottom + 56
      : iconBottom
        ? `calc(${iconBottom} + 3.5rem)`
        : '1.5rem';
  const panelRight = !isRtl ? (iconRight ?? '1rem') : undefined;
  const panelLeft = isRtl ? (iconLeft ?? '1rem') : undefined;
  return { panelBottom, panelRight, panelLeft };
}

export function learnerSidePanelMotionClass(isAnimatingOpen: boolean, isOpen: boolean, isRtl: boolean): string {
  if (isAnimatingOpen) {
    return isRtl ? 'learner-side-panel-enter-rtl' : 'learner-side-panel-enter';
  }
  if (isOpen) return '';
  return isRtl ? 'learner-side-panel-exit-rtl' : 'learner-side-panel-exit';
}
